import './AwardCard.css'

export default function AwardCard({ award }) {
  // Defensive checks for required fields
  if (!award || !award.name) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('AwardCard received invalid award data:', award)
    }
    return null
  }

  const iconMap = {
    trophy: '🏆',
    medal: '🏅',
    bag_tag: '🏅',
    star: '⭐',
    calendar: '📅',
    'trending-up': '📈',
    heart: '❤️',
    zap: '⚡',
    refresh: '🔄',
    'check-circle': '✅',
  }

  // Get the fallback emoji icon
  const getFallbackIcon = () => {
    return iconMap[award.icon_key] || iconMap[award.category] || '🎖️'
  }

  // Priority: custom_icon_url > icon_key > category > default
  let iconDisplay
  if (award.custom_icon_url) {
    // Custom uploaded icon with fallback to emoji on error
    iconDisplay = (
      <>
        <img
          src={award.custom_icon_url}
          alt={`${award.name} icon`}
          className="award-card-custom-icon"
          style={{ width: '48px', height: '48px', objectFit: 'contain' }}
          onError={(e) => {
            // Hide broken image and show fallback emoji
            e.target.style.display = 'none'
            const fallback = e.target.nextSibling
            if (fallback) {
              fallback.style.display = 'inline-block'
            }
          }}
        />
        <span style={{ fontSize: '48px', display: 'none' }}>
          {getFallbackIcon()}
        </span>
      </>
    )
  } else {
    // Use emoji icon from map
    iconDisplay = getFallbackIcon()
  }

  // Handle invalid or missing dates gracefully
  let earnedDate = 'Date unknown'
  if (award.earned_at) {
    try {
      const date = new Date(award.earned_at)
      if (!isNaN(date.getTime())) {
        earnedDate = date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        })
      }
    } catch {
      // Invalid date format, only log in development
      if (process.env.NODE_ENV === 'development') {
        console.warn('Invalid date format for award:', award.earned_at)
      }
    }
  }

  return (
    <div className="award-card">
      <div className="award-card-icon" aria-hidden="true">
        {iconDisplay}
      </div>
      <div className="award-card-content">
        <h4 className="award-card-title">{award.name}</h4>
        {award.description && (
          <p className="award-card-description">{award.description}</p>
        )}
        <div className="award-card-meta">
          <span className="award-earned-date">Earned: {earnedDate}</span>
          {award.metadata?.division_name && (
            <span className="award-context">
              {award.metadata.division_name}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
